export const pollVoteCountTrespass = ({ t }) => t('Reached the vote limit. Remove an existing vote first.');
